<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="prefix + title" hide-footer @hidden="cancelar">

    <div class="modal-body">
      <b-card bg-variant="light">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="mb-3">
            <b-col>
              <lg-form-const-select @change="load()" v-model="situacao" id="situacao" :options="optionsFilterSituacao"
                placeholder="Selecione..." />
            </b-col>
            <b-col>
              <lg-form-input id="searchText" v-model="searchText" />
            </b-col>
            <b-col>
              <b-form-group class="b-form-group-styled d-flex align-items-center">
                <b-button id="localizarDocumento" @click="load" size="sm" class="ml-2" style="height: 30px" pill
                  variant="primary">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="search" />
                  </div>
                  <b-tooltip target="localizarDocumento" title="Clique para localizar documentos"
                    triggers="hover"></b-tooltip>

                </b-button>

                <b-button id="limparDocumento" class="ml-2" style="height: 30px" size="sm" pill variant="primary"
                  @click="limpar">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="eraser" />
                  </div>
                  <b-tooltip target="limparDocumento" title="Clique para limpar os filtros"
                    triggers="hover"></b-tooltip>

                </b-button>

                <b-button v-if="temPrivilegioInclusao()" class="ml-2" pill id="addMultipleDocuments" variant="primary"
                  style="height: 30px" size="sm" @click="addMultipleDocuments">
                  <div class="btn-size-alinhamento">
                    <b-icon scale="1.5" icon="plus" />
                  </div>
                  <b-tooltip target="addMultipleDocuments" title="Adicionar novo..." triggers="hover"></b-tooltip>
                </b-button>

              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <b-table :items="this.records" :fields="fields" responsive="sm" striped :hover="true" show-empty
          :busy="this.busy">
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>

          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(arquivo)="data">
            <div class="link-container">
              <a class="custom-link" @click.prevent="downloadArquivo(data)">{{
                data.item.arquivo.nome
              }}</a>
            </div>
          </template>
          <template #cell(editar)="{ item }">
            <b-button :disabled="!temPrivilegioEdicao()" id="editar" class="my-2" size="sm" pill variant="primary"
              @click="ModalEditar(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip target="editar" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>

          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'switchGrupo'">
              <b-form-checkbox v-model="row.item.situacao" @change="alteraSituacao(row.item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" />
              <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
            </div>
          </template>


        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            Página {{ page }} de {{ totalPage }} - {{ total }} registros
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <ModalDocumentosAdicionarVariosBemTerceiro v-if="showModalAdicionarMultiplos" :id="id" @fechar="fechar"
          :prefix="prefix + title + ' > '" />
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import { downloadArquivo } from "@/components/generators/downloads";
import ModalDocumentosAdicionarVariosBemTerceiro from "./ModalDocumentosAdicionarVariosBemTerceiro.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    ModalDocumentosAdicionarVariosBemTerceiro,
  },
  data() {
    return {
      title: 'Documento de Bem de Terceiro',
      showModal: true,
      showModalAdicionar: false,
      showModalAdicionarMultiplos: false,
      busy: false,
      selectedStatusDocumento: null,
      searchText: "",
      situacao: 1,
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: 1 },
        { key: "filterSituacao", text: "Inativo", value: 0 },
      ],
      fields: [
        { key: "arquivo", label: "Arquivo do Documento", tdClass: "px-3" },
        {
          key: "tipoDocumento.descricao",
          label: "Tipo do Documento",
          tdClass: "px-2",
        },
        { key: "situacao", label: " ", tdClass: "w-1" },
      ],
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/documentobemterceiro`);
  },
  mounted() {
    this.load();
  },
  props: {
    prefix: {
      type: String,
      default: '',
    },
    id: {
      type: Number
    }
  },
  watch: {
    page() {
      this.load()
    },
  },

  methods: {

    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.BEM_TERCEIRO_EDITAR);

    },
    temPrivilegioInclusao() {
      return verificaPrivilegio(PrivilegiosEnum.BEM_TERCEIRO_INCLUIR);

    },
    temPrivilegioAnexar() {
      return verificaPrivilegio(PrivilegiosEnum.BEM_TERCEIRO_ANEXAR);

    },

    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Local Armazenamento?",
        item.arquivo.nome
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },

    ModalEditar(item) {
      this.idEdit = item.id;
      this.showModalAdicionar = true;
    },
    handleSubmit(event) {
      event.preventDefault();
      this.load();
    },
    downloadArquivo(result) {

      if (!this.temPrivilegioAnexar())
        return;
      let item = {
        arquivo: result.item.arquivo.arquivo,
        nomeDocumento: result.item.arquivo.nome,
      };
      downloadArquivo(item);
    },
    closeModal() {
      this.showModal = false;
    },
    async load() {
      var filtro = {};
      if (this.id) {
        filtro.bemTerceiro = this.id;
      }
      if (this.searchText) {
        filtro.descricao = this.searchText;
      }
      if (this.situacao != undefined) {
        filtro.situacao = this.situacao;
      }

      this.busy = true;

      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      });
      this.busy = false;
    },
    addDocument() {
      this.showModalAdicionar = true;
    },
    addMultipleDocuments() {
      this.showModalAdicionarMultiplos = true;
    },
    limpar() {
      this.selectedStatusDocumento = null;
      this.situacao = 1;
      this.searchText = "";
      this.load();
    },
    cancelar() {
      this.$emit("close");
    },
    fechar() {
      this.showModalAdicionar = false;
      this.showModalAdicionarMultiplos = false;
      this.load();
    },
  },
};
</script>

<style scoped>
.custom-link {
  color: blue;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding-top: 1rem;
}

.table-header {
  margin-bottom: 1rem;
}

.b-table td,
.b-table th {
  vertical-align: middle;
}
</style>
